export default __webpack_public_path__ + "static/media/hessahStore4.f53171da.jpg";